module.exports = require('./lib/query-selector');


//////////////////
// WEBPACK FOOTER
// ./~/query-selector/index.js
// module id = 307
// module chunks = 0